module.exports = __webpack_public_path__ + "img/xiaohongshu_round-df.2a31dea9.svg";